import { useSelector } from 'react-redux';

const useUser = () => {
  const user = useSelector((state) => state.user);

  const { getProfile: profileLoading } = useSelector(
    (state) => state.loading.effects.user,
  );

  return {
    isLoading: profileLoading,
    ...user,
  };
};

export default useUser;
